export function TeDecisionFlow() {
  return (
    <div className="pl-3 mt-1 mb-2 border-l-2 border-green-500/30">
      <p className="font-semibold mb-1">TE Decision Flow</p>
      <ol className="list-decimal pl-5 space-y-1">
        <li>
          Is there a TE on file for the same request received?
          <ul className="list-disc pl-5 mt-1 space-y-1">
            <li>
              <strong>No</strong> → Create new TE
            </li>
            <li>
              <strong>Yes</strong> → Make sure the Orders/message match (different senders is ok)
              <ul className="list-disc pl-5 mt-1 space-y-1">
                <li>
                  Has it been over 7 days?
                  <ul className="list-disc pl-5 mt-1 space-y-1">
                    <li>
                      <strong>No</strong> → Upload as Follow Up Document and attach to the TE; Add Notes to &quot;action
                      taken&quot; on TE
                    </li>
                    <li>
                      <strong>Yes</strong> → Does the previous <em>addressed</em> TE on file have MHS documentation?
                      <ul className="list-disc pl-5 mt-1 space-y-1">
                        <li>
                          <strong>Yes</strong> → Upload as Duplicate Document
                        </li>
                        <li>
                          <strong>No</strong> → Create new TE
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ol>
    </div>
  );
}

export function GlobalAlertInstructions() {
  return (
    <div className="pl-3 mt-1 mb-2 border-l-2 border-green-500/30">
      <p className="font-semibold mb-1">Global Alert Instructions</p>
      <p>
        Navigate to Billing Alerts on the patient chart → click the settings button (top-right corner) → select the
        reason for the alert.
      </p>
    </div>
  );
}
